import React from "react";
import {movePage, url} from "../utils/UrlsUtil";
import "../../style/common/header/_header.scss";
import {
    Button,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle, Image
} from "react-bootstrap";
import {post} from "../utils/FetchUtil";
import {Link, useNavigate} from "react-router-dom";
import {useAuth} from "../components/auth/AuthProvider.tsx";
import {popConfirm} from "../utils/MessageUtil.ts";
import {isRakutenSiteSection} from "../const/SiteSectionConst.ts";

interface HeaderProps{
    breadcrumb_list: string[];
    handleClickUpdate?: () => void | undefined;
}

const Header:React.FC<HeaderProps> = ({
    breadcrumb_list = [],
    handleClickUpdate = undefined
}) => {
    const { loginDto, logout } = useAuth();
    const navigate = useNavigate();
    const onClickOrderUpdate = () => {
        if(handleClickUpdate){
            handleClickUpdate();
        }
    }
    const onClickMyPage = () => {
        if(loginDto?.my_page_url){
            movePage(loginDto?.my_page_url);
        }
    }
    const onClickLogout = () => {
        popConfirm(
            "ログアウトします。よろしいですか？", () => {
                post<LoginInfoDto>({
                    action: "/api/login/logout",
                    data: {},
                })
                    .then(() => {
                        logout();
                        navigate('/login');
                    })
                    .catch((reason) => {
                        console.log(reason);
                    })
                    .finally(() => logout());
                //movePage('/logout');
            });
    }
    return (
        <div id="pageHeader" className="row">
            <div className="col-12 text-center geeva-logo-area">
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        {loginDto?.logged_in && <Dropdown>
                            <DropdownToggle>
                                <span className="hum-line"></span>
                            </DropdownToggle>
                            <DropdownMenu>
                                <DropdownItem as={Link} to='/'>HOME</DropdownItem>
                                <DropdownItem as={Link} to='/template'>マイデザインの製作</DropdownItem>
                                <DropdownItem as={Link} to='/order/input'>未発送のご注文</DropdownItem>
                                <DropdownItem as={Link} to='/order/history'>過去のご注文</DropdownItem>
                                <DropdownItem eventKey="1" onClick={onClickLogout}>ログアウト</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>}
                    </div>
                    <div><Link to='/'><Image src={url("/images/logo/geeva_logo.png")} fluid={true} /></Link></div>
                    <div>
                        {handleClickUpdate !== undefined && isRakutenSiteSection(loginDto?.site_section) &&
                            <Button variant="success"
                                    className="btn-update-order"
                                    onClick={onClickOrderUpdate}
                            >
                                最新注文更新
                                <span className="arrow-repeat">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-repeat" viewBox="0 0 16 16">
                                        <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                                        <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                                    </svg>
                                </span>
                            </Button>
                        }
                        {loginDto?.logged_in && !isRakutenSiteSection(loginDto?.site_section) &&
                            <Button variant="success"
                                    className="btn-update-order"
                                    onClick={onClickMyPage}
                            >
                                <span className="arrow-repeat">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                      <path
                                          d="M3 2.5a2.5 2.5 0 0 1 5 0 2.5 2.5 0 0 1 5 0v.006c0 .07 0 .27-.038.494H15a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2.038A3 3 0 0 1 3 2.506zm1.068.5H7v-.5a1.5 1.5 0 1 0-3 0c0 .085.002.274.045.43zM9 3h2.932l.023-.07c.043-.156.045-.345.045-.43a1.5 1.5 0 0 0-3 0zm6 4v7.5a1.5 1.5 0 0 1-1.5 1.5H9V7zM2.5 16A1.5 1.5 0 0 1 1 14.5V7h6v9z"/>
                                    </svg>
                                </span>
                                マイページへ
                            </Button>
                        }
                    </div>
                </div>
            </div>
            <div className="col-12">
                <div className="d-flex justify-content-between breadcrumb-area">
                    {loginDto?.logged_in && breadcrumb_list && breadcrumb_list.length != 0 &&
                        <nav aria-label="breadcrumb" style={{padding: '0 1rem'}}>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">HOME</Link></li>
                                {breadcrumb_list.map((value, index) =>
                                    <li key={`breadcrumb-item_key${index}`} className={`breadcrumb-item${index == breadcrumb_list.length -1 ? ' active' : ''}`} aria-current="page">{value}</li>)
                                }
                            </ol>
                        </nav>
                    }
                    <div></div>
                    <div>
                        {loginDto?.logged_in && <p>
                            ようこそ<br/>
                            <strong>{loginDto?.login_name}さま</strong>
                        </p>}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Header;